import {SvgSimpleRemove2, SvgTailLeft1, TailLeftHeader} from "/components/shared/SvgIcons";
import Link from "next/link";
import {useRouter} from 'next/router'

export default function ViewHeader({title, url}) {
    const router = useRouter();
    const handleCloseClick = (e) => {
        e.preventDefault();
        router.push(url);
    };

    return (
        <div className="flex justify-between px-2 py-2 w-full">
            <Link href={url}>
                <div className="inline-flex justify-center items-center cursor-pointer">
                    <div className='hidden xl:block'>{SvgTailLeft1()}</div>
                    <div className='xl:hidden'>{TailLeftHeader()}</div>
                    <a className="text-gold uppercase text-sm xl:text-md ml-2">
                        <h4>{title}</h4>
                    </a>
                </div>
            </Link>
            <div className="cursor-pointer" onClick={handleCloseClick}>{SvgSimpleRemove2()}</div>
        </div>
    );
}
